import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import useHRCopy from '../hr/i18n/useHRCopy';
import ContactFormPanel from './ContactFormPanel';

// Closing contact band used by the content pages (Hakkımda, Hizmetlerimiz,
// Çalışma İlkelerimiz). İletişim composes ContactFormPanel directly instead,
// since the assistant prompt below would point back at the same page.
//
// `title`/`body` let a page speak in its own words; without them the band
// falls back to the localized default copy.
export default function ContactForm({ title, body }) {
  const navigate = useNavigate();
  const t = useHRCopy().forms.contactBand;

  return (
    <section className="py-24 bg-platinum border-t border-line font-hanken">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true }}
        >
          <h3 className="text-4xl md:text-5xl font-extrabold text-ink tracking-[-0.02em] leading-snug mb-6">
            {title || (
              <>
                {t.title[0]} <br /> {t.title[1]}
              </>
            )}
          </h3>
          <p className="text-steel text-base mb-8">{body || t.body}</p>

          <button
            type="button"
            onClick={() => navigate('/iletisim#chatbot')}
            className="inline-block bg-white text-royal font-semibold py-3 px-6 rounded-sm border border-royal hover:bg-royal hover:text-white transition-colors duration-300"
          >
            {t.button}
          </button>
        </motion.div>

        <ContactFormPanel />
      </div>
    </section>
  );
}
